import { render, staticRenderFns } from "./RepresentativePersonRuleForm.vue?vue&type=template&id=2e90a36b&"
import script from "./RepresentativePersonRuleForm.vue?vue&type=script&lang=js&"
export * from "./RepresentativePersonRuleForm.vue?vue&type=script&lang=js&"
import style0 from "./RepresentativePersonRuleForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports